var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"log",rawName:"v-log",value:({
    type: 'show',
    name: 'PHOTO_TEXT_CARD',
    value: {
      ..._vm.cardCommonParams
    }
  }),expression:"{\n    type: 'show',\n    name: 'PHOTO_TEXT_CARD',\n    value: {\n      ...cardCommonParams\n    }\n  }"}],staticClass:"picture-card",on:{"click":_vm.handlePictureClick}},[_c('a',{staticClass:"link",attrs:{"href":`${_vm.origin}${_vm.jumpLink}`}},[_c('img',{staticClass:"picture-item",attrs:{"src":_vm.pictureUrl,"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }